/* KidsDoit storefront polish */
(function () {
  function initVariantSwatches() {
    document.querySelectorAll('.bls__product-color-swatches').forEach(function (swatch) {
      function check() {
        var styles = window.getComputedStyle(swatch);
        var hasImage = styles.backgroundImage && styles.backgroundImage !== 'none';
        var bg = styles.backgroundColor;
        var transparent = !hasImage && (bg === 'rgba(0, 0, 0, 0)' || bg === 'transparent');
        var value = swatch.getAttribute('data-value') || swatch.getAttribute('data-color') || '';

        if (transparent && value) {
          swatch.classList.add('kidsdoit-swatch-text');
          swatch.setAttribute('title', value);
        }
      }

      // The theme's own swatch script may apply images after initial page load.
      check();
      window.setTimeout(check, 300);
      window.setTimeout(check, 1000);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initVariantSwatches);
  } else {
    initVariantSwatches();
  }
})();
